// extracted by mini-css-extract-plugin
module.exports = {"table":"MiniCourseLogsTable_table__2vbXx"};